import { Link } from "react-router-dom";
import React from "react";
import "../styles/DataCollection.css";

const capabilities = [
  {
    title: "Web Data Extraction",
    description: "Collect relevant information from websites and digital sources in a structured format.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=85",
    alt: "Analytics dashboard showing collected data",
  },
  {
    title: "Data Structuring",
    description: "Convert raw information into clean and organized datasets ready for business use.",
    image: "https://images.unsplash.com/photo-1544383835-bda2bc66a55d?auto=format&fit=crop&w=900&q=85",
    alt: "Organized data represented in a database",
  },
  {
    title: "Data Monitoring",
    description: "Track changing information and maintain updated datasets for ongoing requirements.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=900&q=85",
    alt: "Business data and metrics on a monitor",
  },
  {
    title: "Custom Data Pipelines",
    description: "Build collection workflows based on your source, frequency and business objectives.",
    image: "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?auto=format&fit=crop&w=900&q=85",
    alt: "Connected data points forming a collection pipeline",
  },
];

const DataCollection = () => {
  return (
    <div className="data-page">

      {/* 1. Hero */}
      <section className="data-hero">
        <div>
          <span>DATA SERVICE 02</span>
          <h1>Data Collection & Harvesting</h1>
          <p>
            Transform scattered online information into structured,
            usable datasets through reliable data collection and
            harvesting solutions.
          </p>
        </div>

        <img
          src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=90"
          alt="Data Collection"
        />
      </section>

      {/* 2. Services */}
      <section className="data-services">
        <h2>Our Data Capabilities</h2>
        <p className="data-intro">
          Reliable collection systems turn changing web information into clean, decision-ready data
        </p>

        <div className="data-grid">
          {capabilities.map((capability) => (
            <article key={capability.title}>
              <img src={capability.image} alt={capability.alt} loading="lazy" />
              <div className="data-card-content">
                <h3>{capability.title}</h3>
                <p>{capability.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* 3. Workflow */}
      <section className="data-workflow">
        <h2>From Source to Structured Data</h2>

        <div className="workflow-line">
          <span>Source</span>
          <span>Collect</span>
          <span>Clean</span>
          <span>Structure</span>
          <span>Deliver</span>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="data-cta">
        <h2>Turn Data Into Usable Information</h2>
        <p>
          Tell us what information you need and we can design a
          collection workflow around it.
        </p>
        <Link to="/contact">Discuss Your Data Need →</Link>
      </section>

    </div>
  );
};

export default DataCollection;